import styles from "./style.module.scss";

import DynamicForm, { DynamicFormRef } from "@mavichpe/dynamic-forms";
import AddExemptionFormConfig from "./form";
import { ProductExemptionDataType } from "@/formTypes/ProductExemptionDataType";
import { e } from "mathjs";
import { number } from "yup";
import { showAlert } from "@utils/Alert";
import { useRef } from "react";

type AddExemptionFormProps = {
  onAddExemption: (data: ProductExemptionDataType) => void,
  defaultData: Partial<ProductExemptionDataType>,
  innerForm?: boolean
}

const AddExemptionForm = (props: AddExemptionFormProps) => {
  const { onAddExemption, innerForm = false, defaultData } = props;
  const formRef = useRef<DynamicFormRef>(null);

  const onSubmit = (formData: ProductExemptionDataType) => {
    if (onAddExemption) {
      onAddExemption(formData)
    }
  }

  const isValidExemptionPercentage = (value: number): boolean => {
    const { max_porcentaje_compra = 13 } = defaultData

    if (value > Number(max_porcentaje_compra)) {
      showAlert("danger", "El porcentaje de exoneracion no puede superar el porcentaje de impuestos de la linea de facturacion", { container: "bottom-left" })
      formRef.current?.setFormValue("porcentaje_compra", max_porcentaje_compra, "int")
      return false;
    }
    if (value <= 0) {
      showAlert("danger", "El porcentaje de exoneracion debera ser mayor a 0", { container: "bottom-left" })
      return false;
    }
    return true;
  }

  const onInputChange = (name: keyof ProductExemptionDataType, value: any) => {
    if (name === "porcentaje_compra") {
      const percentageValue = Number(value);
      if (isValidExemptionPercentage(percentageValue)) {
        const montoImpuestos = (defaultData.lineSubtotal || 0) * (percentageValue / 100);
        setTimeout(() => {
          formRef.current?.setFormValue("monto_impuesto", montoImpuestos.toFixed(2), "decimal")
        });
      }
    }
  }

  return (
    <>
      <DynamicForm<ProductExemptionDataType>
        ref={formRef}
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={AddExemptionFormConfig}
        onInputChange={onInputChange}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default AddExemptionForm;